<template>
    <v-container fluid>
        <v-slide-y-transition mode="out-in">

            <v-layout column>
                <v-card-title>
                    <v-btn text @click="toProjetoForm()"><v-icon left>add</v-icon>Adicionar</v-btn>
                    <v-btn text @click="storeProjetos.load()"><v-icon left>refresh</v-icon>Atualizar</v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Pesquisar"
                        clearable
                        single-line
                    ></v-text-field>
                </v-card-title>

                <v-data-table
                    :headers="headers"
                    :search="search"
                    :items="storeProjetos.data"
                    :loading="storeProjetos.isLoading"
                    :items-per-page="10"
                    sort-by="nome"
                    :footer-props="footerProps"
                    class="elevation-1"
                >
                    <template style="d-flex" v-slot:item="{ item }">
                        <tr>
                            <td class="hidden-sm-and-down">{{ item.id }}</td>
                            <td>{{ item.nome }}</td>
                            <td>{{ item.strArquivado }}</td>
                            <td class="text-xs-right">
                                <v-btn icon @click="toProjetoForm(item.id)" text><v-icon medium>list_alt</v-icon></v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <ProjetoForm v-bind:id="projetoFormConfig.id" v-bind:cliente="projetoFormConfig.cliente" v-bind:showDialog="isShowProjetoForm"/>
            </v-layout>
        </v-slide-y-transition>
    </v-container>
</template>

<script>

import Utils from '@/utils/Utils.js';
import { EventBus } from '@/EventBus.js';
import { Store } from '@/utils/Store.js';
import ProjetoForm from '@/views/configuracoes/ProjetoForm.vue'

export default {
    props: ['cliente'],
    components: {
        ProjetoForm
    },
    mounted() {
        EventBus.$on('hideProjetoForm', () => {
            this.isShowProjetoForm = false;
            this.projetoFormConfig.id = null;
            this.projetoFormConfig.cliente = null;
            this.storeProjetos.load({
                params: {
                    cliente: this.cliente
                }
            });
        });
    },
    methods: {
        toProjetoForm(id) {
            if (id) {
                this.projetoFormConfig.id = id;
            }
            this.projetoFormConfig.cliente = this.cliente;
            this.isShowProjetoForm = true;
        }
    },
    created() {
        this.storeProjetos.load({
            params: {
                cliente: this.cliente
            }
        });
    },
    data() {
        return {
            tabs: 0,
            storeProjetos: new Store({
                url: '/projetos/Projetos',
                listeners: {
                    load: (storeEl) => {
                        storeEl.allData = storeEl.allData.map((element) => {
                            element.strArquivado = (element.arquivado) ? 'Sim' : 'Não';

                            return element;
                        });

                        storeEl.data = JSON.parse(JSON.stringify(storeEl.allData));
                    }
                }
            }),
            isTrue: true,
            isShowProjetoForm: false,
            projetoFormConfig: {
                id: null,
                cliente: null
            },
            search: '',
            footerProps: {
                itemsPerPageOptions:  [5, 10, 25, { text: 'Todos', value: -1 }],
                itemsPerPageText: 'Registros por pagina'
            },
            headers: [
                { text: 'Id', align: 'left', sortable: false, value: 'id', width: '100', class: 'hidden-sm-and-down' },
                { text: 'Nome', align: 'left', value: 'nome' },
                { text: 'Arquivado', align: 'left', value: 'strArquivado' },
                { text: '', align: 'center', value: '', width: '100' }
            ]
        };
    }
}
</script>